import { createTypes } from 'redux-create-types';
import { } from 'imports/mapper';
import { ajaxJson } from 'imports/ajax';
import history from 'imports/history';
import { confirmAlert } from 'react-confirm-alert';

const namespace = 'page-exam';

export const examActions = createTypes([
    'toggleSpinner',
    'setError',
    'setExamData',
    'setQuestionState',
    'setQuestion',
    'selectChoice',
    'deSelectChoice'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: examActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: examActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function registerExamApiSuccess(res) {
    return dispatch => {
        dispatch({
            type: examActions.setExamData,
            payload: {
                date: res.data['start_time'],
                endTime: res.data['finish_time'],
                duration: res.data['duration'],
                title: res.data['title'],
            },
        });
        dispatch(getExamStateFromApi(res.data['uid']));
    }
}

function registerExamApiFail(err) {
    return dispatch => {
        dispatch({
            type: examActions.setError,
            payload: err,
            meta: {
                apiName: 'register'
            }
        })
        return dispatch(hideSpinner('register'));
    }
}

function registerExamApi(id) {
    return dispatch => {
        dispatch(showSpinner('register'));
        return ajaxJson.post(`/exams/${id}/register`)
        .then(
            res => dispatch(registerExamApiSuccess(res)),
            err => dispatch(registerExamApiFail(err)),
        )
        .then(() => {
            dispatch(hideSpinner('register'));
        })
    }
}

function getExamStateApiSuccess(res, id) {
    return dispatch => {
        dispatch({
            type: examActions.setQuestionState,
            payload: {
                totalQuestion: res.data['stats']['questions_count'],
                currentQuestion: res.data['stats']['current_question_order'],
                examStatus: res.data['status'],
            }
        });
        if (res.data['status'] === 'running' && res.data['stats']['current_question_order']) {
            dispatch(getQuestionFromApi(id, res.data['stats']['current_question_order']));
        }

        if (res.data['status'] === 'time_finished' || res.data['status'] === 'answered') {
            history.replace('../')
        }
    }
}

function getExamStateApiFail(err) {
    return dispatch => {
        dispatch({
            type: examActions.setError,
            payload: err,
            meta: {
                apiName: 'status'
            }
        })
        return dispatch(hideSpinner('status'));
    }
}

function getExamStateFromApi(id) {
    return dispatch => {
        dispatch(showSpinner('status'));
        return ajaxJson.get(`/exams/${id}/status`)
        .then(
            res => dispatch(getExamStateApiSuccess(res, id)),
            err => dispatch(getExamStateApiFail(err)),
        )
        .then(() => {
            dispatch(hideSpinner('status'));
        })
    }
}

function getQuestionApiSuccess(res) {
    return dispatch => {
        dispatch({
            type: examActions.setQuestion,
            payload: {
                title: res.data['title'],
                description: res.data['description'],
                choices: Object.entries(res.data['choices']).map(item => ({
                    id: item[0],
                    title: item[1]['text'],
                }))
            }
        });
    }
}

function getQuestionApiFail(err) {
    return dispatch => {
        dispatch({
            type: examActions.setError,
            payload: err,
            meta: {
                apiName: 'get-question'
            }
        })
        return dispatch(hideSpinner('get-question'));
    }
}

function getQuestionFromApi(id, order) {
    return dispatch => {
        dispatch(showSpinner('get-question'));
        return ajaxJson.get(`/exams/${id}/questions/${order}`)
        .then(
            res => dispatch(getQuestionApiSuccess(res)),
            err => dispatch(getQuestionApiFail(err)),
        )
        .then(() => {
            dispatch(hideSpinner('get-question'));
        })
    }
}

function postQuestionApiSuccess(res, id) {
    return dispatch => {
        dispatch(deSelectChoice());
        dispatch(getExamStateFromApi(id));
    }
}

function postQuestionApiFail(err) {
    return dispatch => {
        dispatch({
            type: examActions.setError,
            payload: err,
            meta: {
                apiName: 'post-question'
            }
        })
        return dispatch(hideSpinner('post-question'));
    }
}

function postQuestionToApi(id) {
    return (dispatch, getState) => {
        const state = getState().ui.exam;
        if (!state.selectedChoice) {
            return confirmAlert({
                title: 'تایید عدم پاسخ به این سوال',
                message: `به این سوال پاسخ نداده‌اید. از عبور از سوال اطمینان دارید؟`,
                buttons: [
                    {
                        label: 'خیر',
                    },
                    {
                        label: 'بلی',
                        onClick: () => {
                            dispatch(showSpinner('post-question'));
                            return ajaxJson.post(`/exams/${id}/questions/${state.currentQuestion}`, {
                                "answer_choice": state.selectedChoice
                            })
                            .then(
                                res => dispatch(postQuestionApiSuccess(res, id)),
                                err => dispatch(postQuestionApiFail(err)),
                            )
                            .then(() => {
                                dispatch(hideSpinner('post-question'));
                            })
                        }
                    }
                ]
            })
        } else {
            dispatch(showSpinner('post-question'));
            return ajaxJson.post(`/exams/${id}/questions/${state.currentQuestion}`, {
                "answer_choice": state.selectedChoice
            })
            .then(
                res => dispatch(postQuestionApiSuccess(res, id)),
                err => dispatch(postQuestionApiFail(err)),
            )
            .then(() => {
                dispatch(hideSpinner('post-question'));
            })
        }
        
    }
}

function selectChoice(choice) {
    return dispatch => {
        dispatch({
            type: examActions.selectChoice,
            payload: choice,
        })
    }
}

function deSelectChoice() {
    return dispatch => {
        dispatch({
            type: examActions.deSelectChoice,
        })
    }
}

function toggleChoice(choice) {
    return (dispatch, getState) => {
        const state = getState().ui.exam;
        if (state.selectedChoice && state.selectedChoice === choice) {
            dispatch(deSelectChoice());
        } else {
            dispatch(selectChoice(choice));
        }
    }
}

export const examPageActionCreators = {
    registerExamApi,
    postQuestionToApi,
    toggleChoice,
}